export const temporalUnits = [
  'unit.temporal.date',
  'unit.temporal.year_week',
  'unit.temporal.year_month',
  'unit.temporal.year_quarter',
  'unit.temporal.year',
]
